import { gql } from '@apollo/client';

/** 推送历史分页单条（listPushHistoryPage 接口） */
export interface ListPushHistoryPageItem {
  taskDate: string | null;
  dspTaskId: number | null;
  taskName: string | null;
  workIndex: string | null;
  totalParcels: number | null;
  dspName: string | null;
  driverId: number | null;
  driverName: string | null;
  dspAssignedTime: string | null;
  createdBy: string | null;
  assignType: number | null;
  childTaskList: ListPushHistoryPageItem[] | null;
}

export interface ListPushHistoryPageResult {
  content: ListPushHistoryPageItem[];
  total: number;
  pageNum: number;
  pageSize: number;
}

export interface ListPushHistoryPageResponse {
  listPushHistoryPageForDsp: ListPushHistoryPageResult;
}

export interface ListPushHistoryPageVariables {
  request: {
    warehouseId: number;
    startTaskDate: string;
    endTaskDate: string;
    driverId?: number | null;
    areaId?: number | null;
    dspId?: number | null;
    pageNum?: number | null;
    pageSize?: number | null;
  };
}

export const LIST_PUSH_HISTORY_PAGE = gql`
  query ListPushHistoryPageForDsp($request: ListPushHistoryPageRequestInput!) {
    listPushHistoryPageForDsp(request: $request) {
      content {
        taskDate
        dspTaskId
        taskName
        totalParcels
        dspName
        driverId
        driverName
        dspAssignedTime
        createdBy
        assignType
        childTaskList {
          taskDate
          dspTaskId
          taskName
          totalParcels
          dspName
          driverId
          driverName
          dspAssignedTime
          createdBy
          assignType
        }
      }
      total
      pageNum
      pageSize
    }
  }
`;

export const LIST_PUSH_HISTORY_PAGE_FOR_WMS = gql`
  query ListPushHistoryPageForWms($request: ListPushHistoryPageRequestInput!) {
    listPushHistoryPage(request: $request) {
      content {
        taskDate
        dspTaskId
        taskName
        workIndex
        totalParcels
        dspName
        driverId
        driverName
        dspAssignedTime
        createdBy
        assignType
        childTaskList {
          taskDate
          dspTaskId
          taskName
          workIndex
          totalParcels
          dspName
          driverId
          driverName
          dspAssignedTime
          createdBy
          assignType
        }
      }
      total
      pageNum
      pageSize
    }
  }
`;

